import LoadingSpinner from "../../../../../Components/Common/Spinner";
import { isEmpty } from "lodash";
import TableContainer from "../../../../../Components/Common/TableContainer";
import NoDataContent from "../../../../../Components/Common/NoDataContent";
import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import LocalDataSearch from "../../../../../Components/SearchAndFilter";
import DeleteModal from "../../../../../Components/Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteJobInvoiceItemTemplate,
  deleteJobInvoiceItemTemplateSuccess,
  getJobInvoiceItemTemplateData,
  getJobInvoiceItemTemplateList,
} from "../../../../../store/invoiceCrmIT/action";
import InvoiceCrmIT from "../../../../../store/invoiceCrmIT/reducer";
import CreateUpdateBillableItemsTemplate from "../../../../../Components/popUpComponents/CreateUpdateBillableItemsTemplate";
import { toast } from "react-toastify";

const BillableItemsTemplates = () => {
  const allowedFiltersInit = [
    {
      useThisFilter: true,
      filterTitle: "Created Date Range",
      filterType: "DateRange",
      filterProperty: "CreatedDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
  ];

  const dispatch = useDispatch();
  const [dataAPI, setDataAPI] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [createUpdateTemplate, setCreateUpdateTemplate] = useState(false);
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Name",
    "Description",
  ]);

  const [allowedFilters, setAllowedFilters] = useState(allowedFiltersInit);

  const toggleShowFilter = () => {
    setShowFilter(!showFilter);
  };
  const toggleCreateUpdateTemplate = () => {
    setCreateUpdateTemplate(!createUpdateTemplate);
  };

  useEffect(() => {
    dispatch(getJobInvoiceItemTemplateList());
  }, []);

  const { invoiceItemTemplateListAPI, invoiceItemTemplateListLoading } =
    useSelector((state) => ({
      invoiceItemTemplateListAPI:
        state.InvoiceCrmIT.invoiceItemTemplateList?.jobinvoiceitemtemplate_list,
      invoiceItemTemplateListLoading:
        state.InvoiceCrmIT.invoiceItemTemplateListLoading,
    }));

  useEffect(() => {
    if (isEmpty(invoiceItemTemplateListAPI)) return;
    setDataAPI(invoiceItemTemplateListAPI);
  }, [invoiceItemTemplateListAPI]);

  useEffect(() => {
    setLoading(invoiceItemTemplateListLoading);
  }, [invoiceItemTemplateListLoading]);

  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
      },
      {
        Header: "Name",
        accessor: "Name",
        Cell: (cellProps) => (
          <div>
            <div>{cellProps?.row?.original?.Name}</div>
            <div>
              Products inside Temple x{" "}
              {cellProps?.row?.original?.jobinvoiceitemtemplateitem_list.length}{" "}
            </div>
          </div>
        ),
      },

      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn-soft-secondary btn-sm dropdown"
                tag="button"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    handleEditClick(cellProps?.row?.original?.Id);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    setDeleteItem(cellProps?.row?.original.Id);
                    setDeleteModal(true);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );
  const [isEdit, setIsEdit] = useState(false);
  const handleEditClick = (id) => {
    dispatch(getJobInvoiceItemTemplateData({ id }));
    setIsEdit(true);
    setCreateUpdateTemplate(true);
  };

  const { invoiceItemTemplateDataAPI } = useSelector((state) => ({
    invoiceItemTemplateDataAPI:
      state.InvoiceCrmIT.invoiceItemTemplateData?.jobinvoiceitemtemplate_data,
  }));
  console.log("invoiceItemTemplateDataAPI", invoiceItemTemplateDataAPI);

  const handleDeleteCallBack = () => {
    dispatch(deleteJobInvoiceItemTemplate([deleteItem]));
  };
  const { deleteInvoiceItemTemplateAPI } = useSelector((state) => ({
    deleteInvoiceItemTemplateAPI: state.InvoiceCrmIT.deleteInvoiceItemTemplate,
  }));

  useEffect(() => {
    if (isEmpty(deleteInvoiceItemTemplateAPI)) return;
    if (deleteInvoiceItemTemplateAPI.status === 200) {
      toast.success(deleteInvoiceItemTemplateAPI.message);
      dispatch(getJobInvoiceItemTemplateList());
      setDeleteModal(false);
    } else {
      toast.error(deleteInvoiceItemTemplateAPI.message);
    }
    dispatch(deleteJobInvoiceItemTemplateSuccess([]));
  }, [deleteInvoiceItemTemplateAPI]);
  return (
    <div>
      {createUpdateTemplate && (
        <CreateUpdateBillableItemsTemplate
          isOpen={createUpdateTemplate}
          toggle={toggleCreateUpdateTemplate}
          templateData={invoiceItemTemplateDataAPI}
          isEdit={isEdit}
        />
      )}

      <div>
        <LocalDataSearch
          Page={"SettingsPage_StaffLeave_StaffHolidayCalendar"}
          ReceivedDataAPI={dataAPI} // Page Specific
          setSearchInActionShowLoading={setLoading} //Mandatory* can be on and off for search loading if data heavy page I recommend to use it
          // recurringJobListDataAPI={recurringJobListData} // Job Page Spesific
          allowedSearchFilters={allowedSearchFilters}
          searchQuery={searchQuery}
          setSearchFilteredResults={setSearchResult}
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          toggleShowFilter={toggleShowFilter}
          allowedFiltersInit={allowedFiltersInit}
          allowedFilters={allowedFilters}
          setAllowedFilters={setAllowedFilters}
        />
        {deleteModal && (
          <DeleteModal
            show={deleteModal}
            onDeleteClick={handleDeleteCallBack}
            onCloseClick={() => {
              setDeleteModal(false);
            }}
          />
        )}
        <Row className="g-4 align-items-center">
          <Col sm={3}>
            <div className="search-box">
              <Input
                // create search with jobs List Data
                type="search"
                className="form-control search"
                placeholder="Search for..."
                onChange={(e) => setSearchQuery(e.target.value)}
                value={searchQuery}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
          <div className="col-sm-auto ms-auto">
            <div className="hstack gap-2">
              <button
                type="button"
                className="btn btn-info btn-info-filters"
                onClick={toggleShowFilter}
              >
                <i className="ri-filter-3-line align-bottom me-1"></i> Filters
              </button>
              <div
                type="button"
                className="btn btn-success add-btn btn-info-add-jobs"
                id="create-btn"
                onClick={() => {
                  setIsEdit(false);
                  toggleCreateUpdateTemplate();
                }}
              >
                <i className="ri-add-line align-bottom me-1"></i>
                New Template
              </div>
            </div>
          </div>
        </Row>
        <div className={"px-2"}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              {!isEmpty(searchResult) ? (
                <TableContainer
                  columns={columns}
                  data={searchResult || []}
                  isGlobalFilter={false}
                  isAddUserList={false}
                  customPageSize={10}
                  className="custom-header-css"
                  divClass="table-responsive table-card mb-0"
                  tableClass="align-middle table-wrap"
                  theadClass="text-muted"
                  // handleLeadClick={handleLeadClicks}
                  isLeadsFilter={false}
                />
              ) : (
                <>
                  <div>
                    <NoDataContent
                      titleText={` No Results for: ${searchQuery}`}
                      paragraphText={`Try Adjusting your query: ${searchQuery}`}
                      useButton={false}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillableItemsTemplates;
